import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_BEATS} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const Beats = lazy(() =>
  import('../../../screens/Beats')
    .then(module => ({default: module.Beats})));

const BeatsNavigation = [
  {
    path: ROUTE_BEATS,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <Beats />
      </Suspense>
    ),
  },
];

export default BeatsNavigation;
